import { GenericFieldFactory } from "../../_generics/GenericFieldFactory";

export const BaseEntrypointStore = GenericFieldFactory("ENTRYPOINT", null);